import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { RadioGroup } from '../Radio';
import SelectableCard from '../SelectableCard';
import ExpandableContentEstimatePlan from './ExpandableContentEstimatePlan';

export const planData = [
  {
    name: 'Annualized Permium',
    price: '3000.00',
  },
  {
    name: 'Out-of-Pocket',
    price: '3000.00',
  },
  {
    name: 'Estimated Total',
    price: '3000.00',
  },
];

const ExpandableContentEstimatePlanDemo = () => {
  const [value, setValue] = React.useState<string | number>('test-2');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Selectable Card - with optional expand</h4>
        <RadioGroup name={'test1'} value={value} onChange={handleChange}>
          <Row>
            <SelectableCard
              title="Consumer Choice HDHP"
              subtitle1="Imputed Income for tax purposes $2,250"
              subtitle2="Sign up for Health Savings Account and receive $1,000!"
              prePaydPeriod={177.24}
              prePaydPeriodSubtitle="3 persons, per-pay-period"
              radioButtonValue="1"
              selected={value === '1'}
            >
              <ExpandableContentEstimatePlan
                breakdownData={planData}
                pricesBreakdown
              />
            </SelectableCard>
          </Row>
        </RadioGroup>
      </Container>
    </Container>
  );
};

export default ExpandableContentEstimatePlanDemo;
